module.exports = __webpack_public_path__ + "img/horizontal_4_1_pp1_8003.f286006f.png";